import { render } from "./Mixed.vue?vue&type=template&id=70b193c4"
import script from "./Mixed.vue?vue&type=script&lang=ts"
export * from "./Mixed.vue?vue&type=script&lang=ts"
script.render = render

export default script